import { PRIVACY_URL, TERMS_URL } from "../../constants/legalUrls";
import { trackCtaClicked } from "../../analytics/analytics";
import { ANALYTICS_CTAS } from "../../analytics/analytics.constants";

export function LegalLink({ href, children, onClick, enabledClassName, disabledClassName, cta }) {
    if (!href) {
        return (
            <span className={disabledClassName} aria-disabled="true">
                {children}
            </span>
        );
    }

    const handleClick = (event) => {
        if (cta) trackCtaClicked(cta);
        onClick?.(event);
    };

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClick}
            className={enabledClassName}
        >
            {children}
        </a>
    );
}

export default function LegalFooterLinks({ className = "", onLinkClick }) {
    const enabledClassName =
        "inline align-middle font-medium transition hover:text-slate-800";
    const disabledClassName =
        "inline align-middle font-medium text-slate-400 cursor-not-allowed";

    return (
        <p className={className}>
            <LegalLink
                href={TERMS_URL}
                cta={ANALYTICS_CTAS.FOOTER_TERMS}
                onClick={onLinkClick}
                enabledClassName={enabledClassName}
                disabledClassName={disabledClassName}
            >
                Terms &amp; Conditions
            </LegalLink>
            <span className="mx-1.5 inline align-middle text-slate-300" aria-hidden>
                ·
            </span>
            <LegalLink
                href={PRIVACY_URL}
                cta={ANALYTICS_CTAS.FOOTER_PRIVACY}
                onClick={onLinkClick}
                enabledClassName={enabledClassName}
                disabledClassName={disabledClassName}
            >
                Privacy Policy
            </LegalLink>
        </p>
    );
}
